"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMaskChar = exports.defaultFormatChars = void 0;
exports.defaultFormatChars = {
    9: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]"
};
exports.defaultMaskChar = "_";
